import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Lazy-loaded (mermaid + react-markdown are heavy — keep them out of the main chunk).
const ArtifactGallery = React.lazy(() => import("./ArtifactGallery"));
const ArtifactViewer = React.lazy(() => import("./ArtifactViewer"));
const ArtifactEditor = React.lazy(() => import("./ArtifactEditor"));

const artifactsModuleConfig: ModuleConfig = {
  // 🏷️ MODULE IDENTITY — id MUST equal backend permissions.ts moduleId
  id: "artifacts",
  name: "Artifacts",
  description:
    "Publish markdown + Mermaid documents to a shareable tommillerservices.com URL — versioned, with private/unlisted/client/public sharing, PDF export, and anchored comments that email you with context. A Claude-agnostic home for diagrams, briefings and reports.",
  version: "0.1.0",
  enabled: true,
  category: "business",
  order: 19,
  icon: "📄",
  color: "#1F6FEB",

  routes: [
    { path: "/artifacts", component: ArtifactGallery, permissionLevel: "view", useLayout: true },
    { path: "/artifacts/new", component: ArtifactEditor, permissionLevel: "create", useLayout: true },
    { path: "/artifacts/:slug/edit", component: ArtifactEditor, permissionLevel: "edit", useLayout: true },
    {
      path: "/artifacts/:slug",
      component: ArtifactViewer,
      permissionLevel: "view",
      useLayout: true,
      layoutOptions: { noContainer: true },
    },
  ],

  navigation: [
    { label: "Artifacts", path: "/artifacts", icon: "📄", permissionLevel: "view" },
    { label: "New Artifact", path: "/artifacts/new", icon: "✏️", permissionLevel: "create" },
  ],

  // EMPTY — backend permissions.ts is the single source of truth.
  permissions: { view: [], create: [], edit: [], delete: [] },
};

export default artifactsModuleConfig;
